// Fase 4 i18n bundle — Incidencias IA, Inventario, Informe PRTR, Auditoría
import i18n from "@/i18n";

const GL = {
  // Sidebar
  sidebar_incidencias: "Incidencias IA",
  sidebar_inventario: "Inventario de Datos",
  sidebar_informe: "Informe Institucional",
  sidebar_auditoria: "Auditoría",

  // Incidencias
  inc_title: "Incidencias IA",
  inc_subtitle: "Análise de deteccións automatizadas · Red Jetson",
  inc_tab_panoramica: "Panorámica",
  inc_tab_tabla: "Tabla",
  inc_tab_mapa: "Mapa",
  inc_tab_analise: "Análise",
  inc_kpi_total: "Total incidencias",
  inc_kpi_overflow: "Desbordes",
  inc_kpi_resolved_pct: "% Resoltas",
  inc_kpi_sla_pct: "SLA cumprimento",
  inc_evolution_title: "Evolución (30 días)",
  inc_by_concello: "Por concello",
  inc_by_jetson: "Por dispositivo Jetson",
  inc_th_date: "Data",
  inc_th_concello: "Concello",
  inc_th_jetson: "Jetson",
  inc_th_type: "Tipo",
  inc_th_status: "Estado",
  inc_th_actions: "Accións",
  inc_type_overflow: "Desborde",
  inc_type_observation: "Observación",
  inc_view_detail: "Ver detalle",
  inc_export_pdf: "Xerar informe PDF",
  inc_export_ok: "PDF xerado",
  inc_export_error: "Erro ao xerar PDF",
  inc_filter_status: "Estado",
  inc_filter_type: "Tipo",
  inc_filter_all: "Todos",
  inc_privacy_notice: "As imaxes anonimízanse automaticamente por IA (rostros e matrículas) antes da súa visualización. Acceso á imaxe orixinal restrinxido por rol e auditado (RGPD art. 32).",
  inc_privacy_link: "Ver transparencia",
  inc_unblur: "Ver sen difuminar",
  inc_view_anonymized: "Ver con anonimización IA",
  // iter46 · Hover reveal (ADMIN/SUPERVISOR) — evento non auditado
  inc_hover_hint: "Vista temporal · click para fixar",
  inc_original_banner: "ORIXINAL SEN DIFUMINAR · acceso auditado",
  inc_img_processing_title: "Procesando anonimización IA",
  inc_img_processing_sub: "A imaxe está a ser anonimizada polo pipeline de Gemini Vision. Actualiza en uns segundos para vela.",
  inc_unblur_confirm: "A visualización queda rexistrada nun evento de auditoría (RGPD)",
  inc_annotate: "Engadir nota",
  inc_note_placeholder: "Nota interna (visible só para persoal autorizado)",
  inc_note_save: "Gardar",
  inc_note_saved: "Nota gardada",
  inc_no_data: "Sen incidencias para os filtros seleccionados.",

  // Inventario
  inv_title: "Inventario de Datos",
  inv_subtitle: "Fontes de datos · Saúde · Calidade",
  inv_summary_total: "Fontes",
  inv_summary_healthy: "Saudables",
  inv_summary_avg_latency: "Latencia media",
  inv_card_healthy: "Saudable",
  inv_card_degraded: "Degradado",
  inv_card_down: "Sen resposta",
  inv_card_type_http: "API HTTP",
  inv_card_type_mongo: "Mongo local",
  inv_card_last_check: "Última comprobación",
  inv_card_latency: "Latencia",
  inv_card_records: "Rexistros",
  inv_card_freshness: "Frescura",
  inv_card_freshness_hours: "{{h}} h",
  inv_drawer_owner: "Propietario",
  inv_drawer_frequency: "Frecuencia",
  inv_drawer_upstream: "Fonte upstream",
  inv_drawer_history: "Uptime 30 días",
  inv_drawer_uptime: "{{pct}}%",
  inv_drawer_schema: "Esquema",
  inv_coverage_title: "Matriz de cobertura módulo × fonte",
  inv_coverage_body: "Que módulos dependen de cada fonte de datos.",
  inv_export_csv: "Descargar CSV",
  inv_export_json: "Descargar JSON",
  inv_export_ok: "Descarga completada",
  inv_export_error: "Erro ao descargar",

  // Informe
  inf_title: "Informe Institucional PRTR",
  inf_subtitle: "Xerador de documento oficial NextGenerationEU · PRTR",
  inf_step1: "Período e alcance",
  inf_step2: "Módulos",
  inf_step3: "Conclusións",
  inf_step4: "Revisión e xeración",
  inf_period_from: "Dende",
  inf_period_to: "Ata",
  inf_language: "Idioma do documento",
  inf_language_gl: "Galego",
  inf_language_es: "Castelán",
  inf_language_bilingual: "Bilingüe",
  inf_concellos: "Concellos incluídos (baleiro = todos)",
  inf_module_portada: "Portada institucional",
  inf_module_resumo: "Resumo executivo",
  inf_module_geoportal: "Xeoportal e Operativa",
  inf_module_esg: "Indicadores ESG",
  inf_module_carbono: "Pegada de Carbono",
  inf_module_incidencias: "Incidencias IA",
  inf_module_contedores: "Contedores e pesaxes",
  inf_module_contedores_sub: "Inclúe cobertura territorial + top puntos recollida + repartición por tipo residuo.",
  inf_module_inventario: "Inventario de Datos",
  inf_module_conclusions: "Conclusións",
  inf_conclusion_gl: "Conclusións (galego)",
  inf_conclusion_es: "Conclusiones (castellano)",
  inf_conclusion_placeholder: "Escribe as conclusións institucionais que aparecerán no informe…",
  inf_conclusion_max: "Máx. 5000 caracteres",
  inf_review_title: "Revisión final",
  inf_review_lang: "Idioma",
  inf_review_period: "Período",
  inf_review_concellos: "Concellos",
  inf_review_modules: "Módulos activos",
  inf_generate: "Xerar PDF institucional",
  inf_generating: "Xerando…",
  inf_ok: "Informe xerado",
  inf_error: "Erro ao xerar o informe",
  inf_next: "Seguinte",
  inf_prev: "Anterior",
  inf_history_title: "Informes anteriores",
  inf_history_empty: "Aínda non se xerou ningún informe.",
  inf_history_col_date: "Data",
  inf_history_col_period: "Período",
  inf_history_col_author: "Autor",
  inf_history_col_size: "Tamaño",
  inf_history_col_actions: "Accións",
  inf_history_download: "Descargar",
  inf_history_approved: "Aprobado",
  inf_history_draft: "Non aprobado",
  inf_size_kb: "{{kb}} KB",
  inf_role_notice: "Só o rol MANCOMUNIDADE marca o informe como «Aprobado». Xerado con outro rol figura como «Non aprobado».",
  inf_include_photos: "Incluír fotografías nas incidencias",
  inf_include_photos_sub: "Se se activa, as fotografías incluiranse sempre con rostros e matrículas anonimizadas automaticamente por IA, independentemente do rol do usuario que xera o informe (protección RGPD).",
  inf_photos_yes: "✓ Fotografías anonimizadas incluídas ({{n}} incidencias con foto)",
  inf_photos_no: "○ Sen fotografías",

  // Auditoría
  aud_title: "Auditoría",
  aud_subtitle: "Rexistro de accións sensibles (só ADMIN)",
  aud_th_at: "Data",
  aud_th_user: "Usuario",
  aud_th_role: "Rol",
  aud_th_action: "Acción",
  aud_th_meta: "Detalle",
  aud_filter_user: "Filtrar por usuario",
  aud_filter_action: "Filtrar por acción",
  aud_filter_all: "Todas",
  aud_export: "Exportar CSV",
  aud_no_data: "Sen eventos para os filtros seleccionados.",
  aud_total: "{{n}} eventos",

  // Common
  build_phase: "",
  loading: "Cargando…",
};

const ES = {
  sidebar_incidencias: "Incidencias IA",
  sidebar_inventario: "Inventario de Datos",
  sidebar_informe: "Informe Institucional",
  sidebar_auditoria: "Auditoría",

  inc_title: "Incidencias IA",
  inc_subtitle: "Análisis de detecciones automatizadas · Red Jetson",
  inc_tab_panoramica: "Panorámica",
  inc_tab_tabla: "Tabla",
  inc_tab_mapa: "Mapa",
  inc_tab_analise: "Análisis",
  inc_kpi_total: "Total incidencias",
  inc_kpi_overflow: "Desbordamientos",
  inc_kpi_resolved_pct: "% Resueltas",
  inc_kpi_sla_pct: "SLA cumplimiento",
  inc_evolution_title: "Evolución (30 días)",
  inc_by_concello: "Por municipio",
  inc_by_jetson: "Por dispositivo Jetson",
  inc_th_date: "Fecha",
  inc_th_concello: "Municipio",
  inc_th_jetson: "Jetson",
  inc_th_type: "Tipo",
  inc_th_status: "Estado",
  inc_th_actions: "Acciones",
  inc_type_overflow: "Desbordamiento",
  inc_type_observation: "Observación",
  inc_view_detail: "Ver detalle",
  inc_export_pdf: "Generar informe PDF",
  inc_export_ok: "PDF generado",
  inc_export_error: "Error al generar PDF",
  inc_filter_status: "Estado",
  inc_filter_type: "Tipo",
  inc_filter_all: "Todos",
  inc_privacy_notice: "Las imágenes se anonimizan automáticamente por IA (rostros y matrículas) antes de su visualización. Acceso a la imagen original restringido por rol y auditado (RGPD art. 32).",
  inc_privacy_link: "Ver transparencia",
  inc_unblur: "Ver sin difuminar",
  inc_view_anonymized: "Ver con anonimización IA",
  // iter46 · Hover reveal (ADMIN/SUPERVISOR) — evento no auditado
  inc_hover_hint: "Vista temporal · click para fijar",
  inc_original_banner: "ORIGINAL SIN DIFUMINAR · acceso auditado",
  inc_img_processing_title: "Procesando anonimización IA",
  inc_img_processing_sub: "La imagen se está anonimizando por el pipeline de Gemini Vision. Actualiza en unos segundos para verla.",
  inc_unblur_confirm: "La visualización queda registrada en un evento de auditoría (RGPD)",
  inc_annotate: "Añadir nota",
  inc_note_placeholder: "Nota interna (visible solo para personal autorizado)",
  inc_note_save: "Guardar",
  inc_note_saved: "Nota guardada",
  inc_no_data: "Sin incidencias para los filtros seleccionados.",

  inv_title: "Inventario de Datos",
  inv_subtitle: "Fuentes de datos · Salud · Calidad",
  inv_summary_total: "Fuentes",
  inv_summary_healthy: "Saludables",
  inv_summary_avg_latency: "Latencia media",
  inv_card_healthy: "Saludable",
  inv_card_degraded: "Degradado",
  inv_card_down: "Sin respuesta",
  inv_card_type_http: "API HTTP",
  inv_card_type_mongo: "Mongo local",
  inv_card_last_check: "Última comprobación",
  inv_card_latency: "Latencia",
  inv_card_records: "Registros",
  inv_card_freshness: "Frescura",
  inv_card_freshness_hours: "{{h}} h",
  inv_drawer_owner: "Propietario",
  inv_drawer_frequency: "Frecuencia",
  inv_drawer_upstream: "Fuente upstream",
  inv_drawer_history: "Uptime 30 días",
  inv_drawer_uptime: "{{pct}}%",
  inv_drawer_schema: "Esquema",
  inv_coverage_title: "Matriz de cobertura módulo × fuente",
  inv_coverage_body: "Qué módulos dependen de cada fuente de datos.",
  inv_export_csv: "Descargar CSV",
  inv_export_json: "Descargar JSON",
  inv_export_ok: "Descarga completada",
  inv_export_error: "Error al descargar",

  inf_title: "Informe Institucional PRTR",
  inf_subtitle: "Generador de documento oficial NextGenerationEU · PRTR",
  inf_step1: "Período y alcance",
  inf_step2: "Módulos",
  inf_step3: "Conclusiones",
  inf_step4: "Revisión y generación",
  inf_period_from: "Desde",
  inf_period_to: "Hasta",
  inf_language: "Idioma del documento",
  inf_language_gl: "Galego",
  inf_language_es: "Castellano",
  inf_language_bilingual: "Bilingüe",
  inf_concellos: "Municipios incluidos (vacío = todos)",
  inf_module_portada: "Portada institucional",
  inf_module_resumo: "Resumen ejecutivo",
  inf_module_geoportal: "Geoportal y Operativa",
  inf_module_esg: "Indicadores ESG",
  inf_module_carbono: "Huella de Carbono",
  inf_module_incidencias: "Incidencias IA",
  inf_module_contedores: "Contenedores y pesajes",
  inf_module_contedores_sub: "Incluye cobertura territorial + top puntos recogida + repartición por tipo residuo.",
  inf_module_inventario: "Inventario de Datos",
  inf_module_conclusions: "Conclusiones",
  inf_conclusion_gl: "Conclusiones (galego)",
  inf_conclusion_es: "Conclusiones (castellano)",
  inf_conclusion_placeholder: "Escribe las conclusiones institucionales que aparecerán en el informe…",
  inf_conclusion_max: "Máx. 5000 caracteres",
  inf_review_title: "Revisión final",
  inf_review_lang: "Idioma",
  inf_review_period: "Período",
  inf_review_concellos: "Municipios",
  inf_review_modules: "Módulos activos",
  inf_generate: "Generar PDF institucional",
  inf_generating: "Generando…",
  inf_ok: "Informe generado",
  inf_error: "Error al generar el informe",
  inf_next: "Siguiente",
  inf_prev: "Anterior",
  inf_history_title: "Informes anteriores",
  inf_history_empty: "Aún no se ha generado ningún informe.",
  inf_history_col_date: "Fecha",
  inf_history_col_period: "Período",
  inf_history_col_author: "Autor",
  inf_history_col_size: "Tamaño",
  inf_history_col_actions: "Acciones",
  inf_history_download: "Descargar",
  inf_history_approved: "Aprobado",
  inf_history_draft: "No aprobado",
  inf_size_kb: "{{kb}} KB",
  inf_role_notice: "Solo el rol MANCOMUNIDADE marca el informe como «Aprobado». Generado con otro rol figura como «No aprobado».",
  inf_include_photos: "Incluir fotografías en las incidencias",
  inf_include_photos_sub: "Si se activa, las fotografías se incluirán siempre con rostros y matrículas anonimizados automáticamente por IA, independientemente del rol del usuario que genera el informe (protección RGPD).",
  inf_photos_yes: "✓ Fotografías anonimizadas incluidas ({{n}} incidencias con foto)",
  inf_photos_no: "○ Sin fotografías",

  aud_title: "Auditoría",
  aud_subtitle: "Registro de acciones sensibles (solo ADMIN)",
  aud_th_at: "Fecha",
  aud_th_user: "Usuario",
  aud_th_role: "Rol",
  aud_th_action: "Acción",
  aud_th_meta: "Detalle",
  aud_filter_user: "Filtrar por usuario",
  aud_filter_action: "Filtrar por acción",
  aud_filter_all: "Todas",
  aud_export: "Exportar CSV",
  aud_no_data: "Sin eventos para los filtros seleccionados.",
  aud_total: "{{n}} eventos",

  build_phase: "",
  loading: "Cargando…",
};

i18n.addResourceBundle("gl", "common", { fase4: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase4: ES }, true, true);

export default {};
